/* ================================================== */
/* MOBILE MENU
/* ================================================== */

var $menuMobile = $('#menu-mobile'),
	$trigger = $('#mobile-menu-trigger'),
	$focus;

function openMenu() {
	// Accessibility
	$focus = $(':focus');
	$('body').addClass('overflow-hidden');
	disableTabindex($menuMobile);
	$menuMobile.attr('tabindex', '0').focus();
	$('a', $menuMobile).attr('tabindex', '0');
	$trigger.attr('aria-expanded', 'true');

	// Update state
	$menuMobile.attr('data-open', 'true');
	if ($trigger.length) toggleHamburger($trigger.find('.hamburger'));
}

function closeMenu() {
	// Accessibility
	$('body').removeClass('overflow-hidden');
	resetTabindex();
	$menuMobile.attr('tabindex', '-1');
	$('a', $menuMobile).attr('tabindex', '-1');
	$trigger.attr('aria-expanded', 'false');
	$focus.focus();

	// Update state
	$menuMobile.attr('data-open', 'false');
	if ($trigger.length) toggleHamburger($trigger.find('.hamburger'));
}

$(document).ready(function() {
	if ($menuMobile.length) {
		// Toggle on click
		$trigger.click(function() {
			($menuMobile.is('[data-open="false"]')) ? openMenu() : closeMenu();
		});

		// Toggle on “Enter”
		$(document).on('keyup', function(event) {
			if (event.keyCode === 13 && $trigger.is(':focus')) {
				($menuMobile.is('[data-open="false"]')) ? openMenu() : closeMenu();
			}
		});
	}

	// Close on click outside
	$(document).on('click touchend', function(event) {
		if ($menuMobile.length && $menuMobile.is('[data-open="true"]') && $menuMobile.has(event.target).length === 0
			&& $trigger.length && $trigger.has(event.target).length === 0) {
			closeMenu();
		}
	});

	// Close on “Esc”
	$(document).on('keyup', function(event) {
		if (event.keyCode === 27 && $menuMobile.length && $menuMobile.is('[data-open="true"]')) closeMenu();
	});
});